<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onCreate">
    <v-card tile>
      <v-card-title class="grey lighten-2">
        Redigera tågvändning
      </v-card-title>

      <v-card-text class="mt-2">
        <TurnaroundTrainNumberFields>
          <TurnaroundLocationField />
        </TurnaroundTrainNumberFields>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="closeModal">Avbryt</v-btn>
        <v-btn rounded type="submit" color="primary" :loading="updatePending">
          Redigera tågvändning
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { required } from '@/common/validationRules'
import TurnaroundTrainNumberFields from './TurnaroundForm/TurnaroundTrainNumberFields'
import TurnaroundLocationField from './TurnaroundForm/TurnaroundLocationField'

export default {
  name: 'TurnaroundEditModal',

  components: {
    TurnaroundTrainNumberFields,
    TurnaroundLocationField
  },

  props: {
    item: Object
  },

  data: () => ({
    required,
    valid: true,
    updatePending: false
  }),

  created() {
    const updateModel = Object.keys(this.model).reduce((acc, key) => {
      if (key === 'uuid') {
        acc[key] = this.model[key]
      } else {
        acc[key] = this.item[key]
      }
      return acc
    }, {})

    this.$store.set('turnaround/model', updateModel)
  },

  computed: {
    model: sync('turnaround/model')
  },

  methods: {
    async onCreate() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm) return
      this.updatePending = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: ReplaceTurnaroundInput!) {
            replaceTurnaround(payload: $payload) {
              turnaround_uuid
            }
          }
        `,
        variables: {
          payload: {
            delete_uuid: this.item.uuid,
            payload: this.model
          }
        }
      })

      this.updatePending = false
      this.$store.set(`turnaround/data@${this.item.uuid}.deleted`, true)
      this.$store.set(`turnaround/data@${this.model.uuid}`, this.model)
      this.closeModal()
    },

    closeModal() {
      this.$store.commit('turnaround/resetModel')
      this.$emit('close')
    }
  }
}
</script>
